document.addEventListener("DOMContentLoaded", () => {
  const buttonLoginOrRegister = document.querySelector(".button--login-or-register");
  const buttonRegister = document.querySelector(".button--register");
  const buttonPasswordReset = document.querySelector(".button--password-reset");
  
  const popupLogin = document.querySelector(".popup-login");
  const popupLoginClose = document.querySelector(".popup-login__close");

  const popupLoginHeader = document.querySelector(".popup-login__header");
  const popupLoginLogin = document.querySelector(".popup-login__login");
  const popupLoginCreateAccount = document.querySelector(".popup-login__create-account");
  const popupLoginPasswordReset = document.querySelector(".popup-login__password-reset");

  popupLoginClose.addEventListener("click", () => {
    popupLogin.classList.add("hide");
    popupLoginHeader.classList.remove("hide");
    popupLoginLogin.classList.remove("hide");
    popupLoginCreateAccount.classList.remove("hide");
    popupLoginPasswordReset.classList.remove("hide");
    popupLoginCreateAccount.classList.add("hide");
    popupLoginPasswordReset.classList.add("hide");
  });

  buttonLoginOrRegister.addEventListener("click", (event) => {
    event.preventDefault();
    popupLogin.classList.remove("hide");
  });

  buttonRegister.addEventListener("click", (event) => {
    event.preventDefault();
    popupLoginCreateAccount.classList.remove("hide");
    popupLoginHeader.classList.add("hide");
    popupLoginLogin.classList.add("hide");
  });

  buttonPasswordReset.addEventListener("click", (event) => {
    event.preventDefault();
    popupLoginPasswordReset.classList.remove("hide");
    popupLoginHeader.classList.add("hide");
    popupLoginLogin.classList.add("hide");
  });
});
